import { BaseService } from '/@/modules/core/app/services/abstracts/BaseService';
import { ExportResource } from '/@/modules/export/resources/EstateExportResource';
import { ExportType } from '/@/modules/export/constants/ExportType';

export abstract class ExportTypeBaseService extends BaseService {
  type: ExportType;

  resourceId?: number;

  params: Params;

  resource: ExportResource;

  constructor(model: Partial<ExportTypeBaseService> = {}) {
    super();

    this.type = model.type as ExportType;
    this.resourceId = model.resourceId;
    this.params = model.params;

    this.resource = new ExportResource();
  }

  abstract getSnackBarTitle(): string;

  abstract getFilename(): string;

  async download(): Promise<Blob> {
    return this.resource.download(this.type, this.resourceId, this.params);
  }
}
